/* Native Sonderseiten: Lagerauswahl auch bei Sortierung und Reset erhalten. */
(() => {
  if (window.__jcSpecialFacets) return;
  window.__jcSpecialFacets = true;
  const root = document.querySelector('[data-jc-native-special]');
  if (!root) return;
  const url = new URL(location.href);
  if (url.searchParams.get('filter.v.availability') !== '1') {
    url.searchParams.set('filter.v.availability', '1');
    location.replace(url.href);
    return;
  }
  document.querySelectorAll('.sale-page a[href], [data-sale-filter-link]').forEach(el => {
    const attr = el.hasAttribute('data-sale-filter-link') ? 'data-sale-filter-link' : 'href';
    const target = new URL(el.getAttribute(attr), location.href);
    if (target.origin !== location.origin || target.pathname !== location.pathname) return;
    target.searchParams.set('filter.v.availability', '1');
    el.setAttribute(attr, target.pathname + target.search);
  });
})();
